import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-unauthorized',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule],
  template: `
    <div class="min-h-screen flex items-center justify-center bg-gray-50">
      <div class="max-w-md w-full bg-white rounded-lg shadow-md p-8 text-center">
        <div class="mb-6">
          <mat-icon class="text-6xl text-red-500 mb-4">block</mat-icon>
          <h1 class="text-2xl font-bold text-gray-900 mb-2">Acceso Denegado</h1>
          <p class="text-gray-600">
            No tienes permisos para acceder a esta página o tu sesión ha expirado.
          </p>
        </div>
        
        <div class="space-y-4">
          <button 
            mat-raised-button 
            color="primary" 
            class="w-full"
            (click)="goToHome()"
          >
            <mat-icon class="mr-2">home</mat-icon>
            Ir al Inicio
          </button>
          
          <button 
            mat-stroked-button 
            color="primary" 
            class="w-full"
            (click)="goToLogin()"
          >
            <mat-icon class="mr-2">login</mat-icon>
            Iniciar Sesión
          </button>
        </div>
      </div>
    </div>
  `
})
export class UnauthorizedComponent {
  constructor(private router: Router) {}

  goToHome(): void {
    this.router.navigate(['/']);
  }

  goToLogin(): void {
    this.router.navigate(['/login']);
  }
} 